export default __webpack_public_path__ + "static/ShopeePay_logo-cc2cfbce11baf3ea42d0d230f632999b.png";